var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ModalContent', {
    attrs: {
      "flat-chrome": "",
      "help-content-id": "popup-customer-".concat(_vm.current_entity_profile)
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm.customer !== null ? _c('template', {
    slot: "content"
  }, [_c('div', {
    staticClass: "stitch-modal general-settings-reference stitch-form"
  }, [_vm.isExternal ? _c('Warning', {
    attrs: {
      "elevation": 2
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("instructionsExternal")) + " ")]) : _vm._e(), _vm.showRequiredFeedback ? _c('p', {
    staticClass: "required-fields-legend mb-4"
  }, [_vm._v(" " + _vm._s(_vm.$translate("requiredFieldsLegend")) + " ")]) : _vm._e(), _c('v-card', {
    staticClass: "stitch-modal__card customer-configuration-card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-account-cog-outline")]), _c('span', [_vm._v(_vm._s(_vm.$translate("customerConfiguration")))])], 1), _c('v-row', {
    staticClass: "stitch-modal__fields",
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_vm.customer.type == 'company' || !_vm.customer.type ? _c('CompanySearchAutocomplete', {
    attrs: {
      "error-messages": _vm.nameErrorMessages,
      "label": _vm.$translate('labels.name'),
      "placeholder": _vm.$translate('placeholders.companyName'),
      "dense": true,
      "outlined": "",
      "autofocus": true
    },
    on: {
      "company-selected": _vm.onCompanySelected,
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.customer.name,
      callback: function callback($$v) {
        _vm.$set(_vm.customer, "name", $$v);
      },
      expression: "customer.name"
    }
  }) : _c('v-text-field', {
    attrs: {
      "error-messages": _vm.nameErrorMessages,
      "label": _vm.$translate('labels.name'),
      "placeholder": _vm.$translate('placeholders.individualName'),
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "autofocus": true
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.customer.name,
      callback: function callback($$v) {
        _vm.$set(_vm.customer, "name", $$v);
      },
      expression: "customer.name"
    }
  })], 1), _vm.customer.type == 'company' || !_vm.customer.type ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('CompanySearchAutocomplete', {
    attrs: {
      "value": _vm.customer.legal_name,
      "error-messages": _vm.customer_saving_errors.legal_name,
      "label": _vm.$translate('labels.legal_name'),
      "placeholder": _vm.$translate('placeholders.legal_name'),
      "dense": true,
      "outlined": ""
    },
    on: {
      "input": _vm.onLegalNameInput,
      "company-selected": _vm.onLegalNameCompanySelected,
      "keydown": _vm.handleKeyPress
    }
  })], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-select', {
    staticClass: "flex-grow-0 w-sm-100",
    attrs: {
      "required": "",
      "label": _vm.$translate('labels.type'),
      "error-messages": _vm.customer_saving_errors.type,
      "items": _vm.typesChoices,
      "value": _vm.customer.type || 'company',
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    on: {
      "input": function input($event) {
        _vm.customer.type = $event;
        _vm.$forceUpdate();
      },
      "keydown": _vm.handleKeyPress
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.customer_saving_errors.code,
      "label": _vm.$translate('codeLabel'),
      "name": "code",
      "dense": "",
      "outlined": "",
      "hide-details": "auto"
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', [_vm._v(_vm._s(_vm.$translate("codeLabel"))), _c('StitchHint', {
          attrs: {
            "hint": _vm.$translate('labels.codeAutomaticallyGenerated')
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 2564811211),
    model: {
      value: _vm.customer.code,
      callback: function callback($$v) {
        _vm.$set(_vm.customer, "code", $$v);
      },
      expression: "customer.code"
    }
  })], 1), _vm.customer.type == 'company' || !_vm.customer.type ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('CompanySiren', {
    staticClass: "flex-grow-0 w-sm-100",
    attrs: {
      "error-messages": _vm.sirenErrorMessages,
      "required": _vm.highlightMandatory,
      "label": _vm.$translate('labels.siren'),
      "placeholder": _vm.$translate('placeholders.siren'),
      "dense": true,
      "outlined": ""
    },
    on: {
      "company-selected": _vm.onCompanySelected,
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.customer.siren,
      callback: function callback($$v) {
        _vm.$set(_vm.customer, "siren", $$v);
      },
      expression: "customer.siren"
    }
  })], 1) : _vm._e(), _vm.customer.type == 'company' || !_vm.customer.type ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "flex-grow-0 w-sm-100",
    attrs: {
      "error-messages": _vm.customer_saving_errors.vat_number,
      "label": _vm.$translate('labels.vatNumber'),
      "name": "vat_number",
      "dense": "",
      "outlined": "",
      "hide-details": "auto"
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.customer.vat_number,
      callback: function callback($$v) {
        _vm.$set(_vm.customer, "vat_number", $$v);
      },
      expression: "customer.vat_number"
    }
  })], 1) : _vm._e(), _vm.customer.type == 'company' || !_vm.customer.type ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-select', {
    staticClass: "flex-grow-0 w-sm-100",
    attrs: {
      "required": "",
      "label": _vm.$translate('labels.businessActivity'),
      "error-messages": _vm.customer_saving_errors.persona,
      "items": _vm.personasChoices,
      "value": _vm.customer.persona || 'company',
      "hide-details": "auto",
      "dense": "",
      "outlined": ""
    },
    on: {
      "input": function input($event) {
        _vm.customer.persona = $event;
        _vm.$forceUpdate();
      },
      "keydown": _vm.handleKeyPress
    }
  })], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": _vm.customer.type == 'company' || !_vm.customer.type ? 8 : 12
    }
  }, [_c('TagInput', {
    attrs: {
      "object-type": "customer",
      "label": _vm.$translate('labels.tags'),
      "placeholder": _vm.$translate('placeholders.tags'),
      "dense": true,
      "outlined": "",
      "hide-details": "auto",
      "error-messages": _vm.customer_saving_errors.tags
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.customer.tags,
      callback: function callback($$v) {
        _vm.$set(_vm.customer, "tags", $$v);
      },
      expression: "customer.tags"
    }
  })], 1), _vm.catalogs && _vm.isOperator ? [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('Select', {
    staticClass: "flex-grow-0 w-sm-100",
    attrs: {
      "required": "",
      "label": _vm.$translate('labels.catalog'),
      "error-messages": _vm.customer_saving_errors.catalog,
      "options": _vm.catalogs.map(function (c) {
        return {
          text: c.name + (c["default"] ? " (".concat(_vm.$translate('labels.defaultCatalog'), ")") : ''),
          value: c.id
        };
      }),
      "value": _vm.allowed_catalogs ? _vm.allowed_catalogs[0] : null,
      "dense": true,
      "outlined": ""
    },
    on: {
      "input": function input($event) {
        _vm.updateAllowedCatalogs([$event]);
        _vm.$forceUpdate();
      }
    }
  })], 1)] : _vm._e()], 2)], 1)], 1), _c('v-card', {
    staticClass: "stitch-modal__card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-file-document-outline")]), _c('span', [_vm._v(_vm._s(_vm.$translate("billingInformation")))])], 1), _c('v-row', {
    staticClass: "stitch-modal__fields",
    attrs: {
      "dense": ""
    }
  }, [_vm.billingaccounts.length ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('Select', {
    staticClass: "flex-grow-0 w-sm-100",
    attrs: {
      "required": "",
      "label": _vm.$translate('labels.billingAccount'),
      "error-messages": _vm.customer_saving_errors.billingaccount,
      "options": _vm.billingaccountsChoices,
      "value": _vm.customer.billingaccount,
      "loading": _vm.billingaccounts_loading,
      "disabled": _vm.billingaccounts_loading,
      "dense": true,
      "outlined": ""
    },
    on: {
      "input": function input($event) {
        return _vm.changeBillingAccountId($event);
      }
    }
  })], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "flex-grow-0 w-sm-100",
    attrs: {
      "value": _vm.customer.force_vat_rate ? _vm.decimal(_vm.customer.force_vat_rate).times(100).toFixed(2) : null,
      "error-messages": _vm.customer_saving_errors.force_vat_rate,
      "label": _vm.$translate('labels.vatRate'),
      "placeholder": _vm.$translate('placeholders.vatRate', {
        "default": _vm.defaultVatRate
      }),
      "name": "force_vat_rate",
      "dense": "",
      "outlined": "",
      "hide-details": "auto"
    },
    on: {
      "focusout": function focusout($event) {
        return _vm.changeVatRate($event);
      },
      "keydown": _vm.handleKeyPress
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "flex-grow-0 w-sm-100",
    attrs: {
      "value": _vm.customer.default_payment_delay,
      "error-messages": _vm.customer_saving_errors.default_payment_delay,
      "label": _vm.$translate('labels.paymentDelay'),
      "name": "default_payment_delay",
      "dense": "",
      "outlined": "",
      "hide-details": "auto"
    },
    on: {
      "input": _vm.updateDefaultPaymentDelay,
      "keydown": _vm.handleKeyPress
    }
  })], 1)], 1)], 1)], 1), _c('v-card', {
    staticClass: "stitch-modal__card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-credit-card-outline")]), _c('span', [_vm._v(_vm._s(_vm.$translate("paymentMethodSection")))])], 1), _c('v-row', {
    staticClass: "stitch-modal__fields",
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-select', {
    staticClass: "flex-grow-0 w-sm-100",
    attrs: {
      "value": _vm.customer.preferred_payment_method,
      "items": _vm.paymentMethodChoices,
      "label": _vm.$translate('labels.preferredPaymentMethod'),
      "error-messages": _vm.customer_saving_errors.preferred_payment_method,
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "clearable": ""
    },
    on: {
      "input": _vm.updatePreferredPaymentMethod
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "stitch-modal__fields",
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.customer.debit_iban,
      "error-messages": _vm.customer_saving_errors.debit_iban,
      "label": _vm.$translate('labels.debitIban'),
      "dense": "",
      "outlined": "",
      "hide-details": "auto"
    },
    on: {
      "input": function input($event) {
        return _vm.updateDebitField('debit_iban', $event);
      }
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.customer.debit_bic,
      "error-messages": _vm.customer_saving_errors.debit_bic,
      "label": _vm.$translate('labels.debitBic'),
      "dense": "",
      "outlined": "",
      "hide-details": "auto"
    },
    on: {
      "input": function input($event) {
        return _vm.updateDebitField('debit_bic', $event);
      }
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.customer.debit_account_holder,
      "error-messages": _vm.customer_saving_errors.debit_account_holder,
      "label": _vm.$translate('labels.debitAccountHolder'),
      "dense": "",
      "outlined": "",
      "hide-details": "auto"
    },
    on: {
      "input": function input($event) {
        return _vm.updateDebitField('debit_account_holder', $event);
      }
    }
  })], 1), _vm.customer.preferred_payment_method === 'direct_debit' && !_vm.customer.debit_iban ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "text-caption mb-0"
  }, [_vm._v(" " + _vm._s(_vm.$translate("debitIbanMissing")) + " ")])]) : _vm._e()], 1)], 1)], 1), _c('v-card', {
    staticClass: "stitch-modal__card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-map-marker-outline")]), _c('span', [_vm._v(_vm._s(_vm.$translate("labels.billingAddress")))])], 1), _c('v-row', {
    staticClass: "stitch-modal__fields",
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('AddressForm', {
    attrs: {
      "title": '',
      "value": _vm.customer.billing_address,
      "errors": _vm.billingAddressErrors,
      "highlight-mandatory": _vm.showRequiredFeedback,
      "show-required-indicators": _vm.showRequiredFeedback,
      "outlined": ""
    },
    on: {
      "input": function input($event) {
        return _vm.updateBillingAddress($event);
      },
      "keydown": _vm.handleKeyPress
    }
  })], 1), _vm.isNew ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h6', {
    staticClass: "stitch-modal__title stitch-modal__title--sub"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-truck-delivery-outline")]), _c('span', [_vm._v(_vm._s(_vm.$translate("labels.deliveryAddress")))])], 1), _c('v-checkbox', {
    attrs: {
      "label": _vm.$translate('labels.deliveryAddressSameAsBilling'),
      "dense": ""
    },
    model: {
      value: _vm.deliveryAddressSameAsBilling,
      callback: function callback($$v) {
        _vm.deliveryAddressSameAsBilling = $$v;
      },
      expression: "deliveryAddressSameAsBilling"
    }
  }), !_vm.deliveryAddressSameAsBilling ? _c('AddressForm', {
    attrs: {
      "value": _vm.customer.delivery_address || {},
      "errors": _vm.customer_saving_errors.delivery_address,
      "outlined": ""
    },
    on: {
      "input": function input(value) {
        return _vm.customer.delivery_address = value;
      }
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1), _vm.stocks && _vm.isOperator ? _c('v-card', {
    staticClass: "stitch-modal__card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-warehouse")]), _c('span', [_vm._v(_vm._s(_vm.$translate("warehouses")))])], 1), _c('p', {
    staticClass: "stitch-modal__hint"
  }, [_vm._v(" " + _vm._s(_vm.$translate("warehousesHint")) + " ")]), _c('div', {
    staticClass: "stitch-modal__stack"
  }, _vm._l(_vm.stocks, function (stock) {
    return _c('v-switch', {
      key: stock.id,
      attrs: {
        "input-value": _vm.isStockAllowed(stock),
        "label": stock.name,
        "dense": "",
        "inset": "",
        "hide-details": ""
      },
      on: {
        "change": function change($event) {
          return _vm.toggleStock(stock);
        }
      }
    });
  }), 1)])], 1) : _vm._e(), _c('v-card', {
    ref: "commentsSectionRef",
    staticClass: "stitch-modal__card customer-modal-section",
    "class": {
      'customer-modal-section-highlight': _vm.highlightCommentsSection
    },
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-text-box-outline")]), _c('span', [_vm._v(_vm._s(_vm.$translate("additionalInformation")))])], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "error-messages": _vm.customer_saving_errors.comments,
      "label": _vm.$translate('labels.comments'),
      "placeholder": _vm.$translate('placeholders.comments'),
      "dense": "",
      "outlined": "",
      "hide-details": "auto"
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.customer.comments,
      callback: function callback($$v) {
        _vm.$set(_vm.customer, "comments", $$v);
      },
      expression: "customer.comments"
    }
  })], 1)], 1)], 1)], 1)], 1)]) : _vm._e(), _c('template', {
    slot: "bottom"
  }, [_c('v-btn', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto text-none",
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.cancelEditClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("buttons.cancel")) + " ")]), _c('v-btn', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto ml-sm-3 text-none",
    attrs: {
      "color": "primary",
      "disabled": _vm.customer_saving,
      "loading": _vm.customer_saving
    },
    on: {
      "click": _vm.saveInformationClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("buttons.saveInformations")) + " ")])], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }